import * as z from "zod/v4";
import { accountIdFormat } from "../../ids";

export const CompetitorOutputSchema = z.object({
  name: z.string(),
  website: z.string(),
  competitionScore: z.number().int().min(1).max(10),
  competitiveCategory: z.string(),
});
export type CompetitorOutput = z.infer<typeof CompetitorOutputSchema>;

export const BrandIdentityGuideSchema = z.object({
  teamId: z.string(),
  name: z.string(),
  storefrontUrl: z.string(),
  headquarters: z.string().optional(),
  foundedDate: z.date().optional(),
  industry: z.string().optional(),
  companyDescription: z.string().optional(),
  brandVoice: z.string().optional(),
  missionStatement: z.string().optional(),
  marketPosition: z.string().optional(),
  competitiveDifferentiation: z.string().optional(),
  coreValues: z.array(z.string()).optional(),
  targetAudience: z.string().optional(),
  contentStrategy: z.string().optional(),
  brandKeywords: z.string().optional(),
  competitors: z.array(CompetitorOutputSchema).optional(),
});
export type BrandIdentityGuide = z.infer<typeof BrandIdentityGuideSchema>;

export const brandIdentityGuideGeneratedFieldNames = [
  "headquarters",
  "foundedDate",
  "industry",
  "companyDescription",
  "brandVoice",
  "missionStatement",
  "marketPosition",
  "competitiveDifferentiation",
  "coreValues",
  "targetAudience",
  "contentStrategy",
  "brandKeywords",
  "competitors",
] as const;

export type BrandIdentityGuideGeneratedFieldName =
  (typeof brandIdentityGuideGeneratedFieldNames)[number];

export const BrandIdentityGuideGeneratedFieldLabels = {
  headquarters: "Headquarters",
  foundedDate: "Founded Date",
  industry: "Industry",
  companyDescription: "Company Description",
  brandVoice: "Brand Voice",
  missionStatement: "Mission Statement",
  marketPosition: "Market Position",
  competitiveDifferentiation: "Competitive Differentiation",
  coreValues: "Core Values",
  targetAudience: "Target Audience",
  contentStrategy: "Content Strategy",
  brandKeywords: "Brand Keywords",
  competitors: "Competitors",
} satisfies Record<BrandIdentityGuideGeneratedFieldName, string>;

export const FrontEndBrandIdentityGuideSchema = z.object({
  id: z.string(),
  companyName: z.string(),
  website: z.string(),
  headquarters: z.string(),
  foundedYear: z.string(),
  industry: z.string(),
  companyDescription: z.string(),
  brandVoice: z.string(),
  missionStatement: z.string(),
  contentStrategy: z.string(),
  marketPosition: z.string(),
  competitiveDifferentiation: z.string(),
  coreValues: z.array(z.string()),
  targetAudience: z.string(),
  brandKeywords: z.string(),
  competitors: z.array(CompetitorOutputSchema),
});

// TODO: Replace all the brand identity guide schemas with this one.
export const CompleteBrandIdentityGuideSchema = z.object({
  id: z.bigint(),
  accountId: accountIdFormat.schema,
  name: z.string(),
  storefrontUrl: z.string(),
  headquarters: z.string().optional(),
  foundedDate: z.date().optional(),
  industry: z.string().optional(),
  companyDescription: z.string().optional(),
  brandVoice: z.string().optional(),
  missionStatement: z.string().optional(),
  marketPosition: z.string().optional(),
  competitiveDifferentiation: z.string().optional(),
  brandPersonality: z.string().optional(),
  coreValues: z.array(z.string()).optional(),
  targetAudience: z.string().optional(),
  contentStrategy: z.string().optional(),
  brandKeywords: z.string().optional(),
  competitors: z.array(CompetitorOutputSchema).optional(),
});
export type CompleteBrandIdentityGuide = z.infer<
  typeof CompleteBrandIdentityGuideSchema
>;
